import { ValidatorFn } from "@angular/forms";

export interface FieldConfig {
    label: string,
    enbeddedLabel?: boolean,
    name: string,
    color?: string,
    value?: any,
    defaultValue?: string,
    placeholder?: string,
    alphabeticOnly?: boolean,
    numericOnly?: boolean,
    type?: FieldType,
    subType?: string,
    disabled?: boolean,
    validation?: ValidatorFn[],
    options?: any[],
    minDate?: string,
    maxDate?: string,
    selectedItemPrefix?: boolean,
    labelPrefix?: string,
    iconPrefix?: string,
    fields?: FieldConfig[],
    width?: string | number,
    action?: string,
    classes?: string,
    visibleLabel?: boolean,
    icon?: string,
    iconClass?: string,
    visible?: string,
    optionLabel?: string,
    tooltip?: string,
    composite?: boolean,
    customStyle?: boolean,
    status?: string,
    actionButton?: ActionConfig
}

export interface ActionConfig {
    isDisplayed?: boolean,
    type?: ActionApiKey
}
export enum ActionApiKey {
    activate = 'activate',
    regenerate = 'regenerate'
}

export interface SelectOption {
    name: string,
    value: any,
}

export enum FieldType {
    input = 'input',
    email = 'email',
    password = 'password',
    button = 'button',
    select = 'select',
    multiselect = 'multiselect',
    autocomplete = 'autocomplete',
    textarea = 'textarea',
    checkbox= 'checkbox',
    spacer = 'spacer',
    fields = 'fields',
}

export enum TagType {
    success = 'success',
    secondary = 'secondary',
    danger = 'danger'
}
